import { Button, Card, Col, Form, Row, InputGroup } from "react-bootstrap";
import config from "../../../config/config.json";
import { FiCheck, FiCopy, FiEye } from "react-icons/fi";
import UseToggle from "../../../Hooks/UseToggle";
import AddWidget from "./AddWidget";
import { useEffect, useState } from "react";
import { widgetServices } from "../../../APIServices/SitePilotManagement/widgetServices";
import { GoTrash } from "react-icons/go";
import Swal from "sweetalert2";
import { CiSquarePlus } from "react-icons/ci";
import AdvanceConsentForm from "./AdvanceConsentForm";
import AdvanceScheduler from "./AdvanceScheduler";
import AdvanceWidgetAppearance from "./AdvanceWidgetAppearance";
import ConfigureDomainRestriction from "./ConfigureDomainRestriction";
import ConfigureCountryRestriction from "./ConfigureCountryRestriction";
import ConfigurePlateformRestriction from "./ConfigurePlateformRestriction";

const ChatWidgetData = () => {
  const toggles = UseToggle();
  const [widgetId, setWidgetId] = useState("");
  const [loader, setLoader] = useState(false);
  const [saveLoader, setSaveLoader] = useState(false);
  const [widgetList, setWidgetList] = useState([]);
  const [copied, setCopied] = useState(false);
  const [widgetCategory, setWidgetCategory] = useState("");

  const [widgetName, setWidgetName] = useState("");
  const [widgetIdentifier, setWidgetIdentifier] = useState("");
  const [widgetStatus, setWidgetStatus] = useState(false);
  const [widgetChatLanguage, setWidgetChatLanguage] = useState("english");
  const [widgetVoiceAndVideoCall, setWidgetVoiceAndVideoCall] = useState(false);

  const [hideEstimatedWaitTime, setHideEstimatedWaitTime] = useState(false);
  const [disableAgentTypingNotification, setDisableAgentTypingNotification] =
    useState(false);
  const [disableSoundNotification, setDisableSoundNotification] =
    useState(false);
  const [
    disableVisitorTypingNotification,
    setDisableVisitorTypingNotification,
  ] = useState(false);
  const [disableMessagePreviewOnDesktop, setDisableMessagePreviewOnDesktop] =
    useState(false);
  const [disableBrowserTabNotification, setDisableBrowserTabNotification] =
    useState(false);
  const [disableMessagePreviewOnMobile, setDisableMessagePreviewOnMobile] =
    useState(false);

  const [hideWhenOffline, setHideWhenOffline] = useState(false);
  const [hideOnDesktop, setHideOnDesktop] = useState(false);
  const [hideOnMobile, setHideOnMobile] = useState(false);
  const [
    widgetOfflineWhenAllAgentOffline,
    setWidgetOfflineWhenAllAgentOffline,
  ] = useState(false);

  const [disableEmojiReaction, setDisableEmojiReaction] = useState(false);
  const [disableFileUpload, setDisableFileUpload] = useState(false);
  const [disableChatRating, setDisableChatRating] = useState(false);
  const [disableChatTranscript, setDisableChatTranscript] = useState(false);
  const [widgetColorSettings, setWidgetColorSettings] = useState("");
  const [widgetSchedulerSettings, setWidgetSchedulerSettings] = useState("");
  const [widgetConsentSettings, setWidgetConsentSettings] = useState("");
  const [widgetDomainRestrictionSettings, setWidgetDomainRestrictionSettings] = useState("");
  const [widgetCountryRestrictionSettings, setWidgetCountryRestrictionSettings] = useState("");
  const [widgetPlateformRestrictionSettings, setWidgetPlateformRestrictionSettings] = useState("");

  const [visitorInfoForm, setVisitorInfoForm] = useState(false);
  const [visitorInfo, setVisitorInfo] = useState([
    { label: "Name", required: "yes", value: "" },
    { label: "Email", required: "yes", value: "" },
    { label: "Phone", required: "no", value: "" },
    { label: "Company Name", required: "no", value: "" },
  ]);

  const colors = [
    "#FF5733",
    "#33FF57",
    "#3357FF",
    "#FF33A8",
    "#A833FF",
    "#33FFF3",
    "#FFC733",
    "#FF8F33",
    "#33FF8F",
    "#8FFF33",
    "#FF3333",
    "#33FF33",
    "#3333FF",
    "#FF33FF",
    "#33FFFF",
    "#999999",
    "#000000",
    "#F1C40F",
    "#2ECC71",
  ];

  const DAYS = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  let initialConsentSettings = {
    requireConsent: "disabled",
    consentMessage: "",
    privacyLink: "",
    privacyText: "",
    optInText: "Yes, I Accept",
    optOutText: "No, Not Now",
  }

  const widgetConsentChangeSettings = (e) => {
    const { name, value } = e.target;
    setWidgetConsentSettings((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  let initialColorSettings = {
    width: 50,
    height: 50,
    iconSize: 30,
    textSize: 0,
    color: "#0d6efd",
    position: "right",
    shape: "rounded",
    text: "",
    icon: "IoChatbox",
    imageLink: "",
  }

  let initialDomainRestrictionSettings = {
    domainRestriction: false,
    showEnabled: false,
    showDomains: [""],
    hideEnabled: false,
    hideDomains: [""],
  }

  const updateWidgetDomainRestrictionSettings = (type, index, value) => {
    setWidgetDomainRestrictionSettings((prev) => {
      const updated = [...prev[type]];
      updated[index] = value;
      return {
        ...prev,
        [type]: updated,
      };
    });
  };

  const toggleWidgetDomainRestrictionSettings = (key, checked) => {
    setWidgetDomainRestrictionSettings((prev) => ({
      ...prev,
      [key]: checked,
    }));
  };

  let initialCountryRestrictionSettings = {
    countryRestriction: false,
    showEnabled: false,
    showCountries: [""],
    hideEnabled: false,
    hideCountries: [""],
  }

  const updateWidgetCountryRestrictionSettings = (type, index, value) => {
    setWidgetCountryRestrictionSettings((prev) => {
      const updated = [...prev[type]];
      updated[index] = value;
      return {
        ...prev,
        [type]: updated,
      };
    });
  };

  const toggleWidgetCountryRestrictionSettings = (key, checked) => {
    setWidgetCountryRestrictionSettings((prev) => ({
      ...prev,
      [key]: checked,
    }));
  };

  let initialPlateformRestrictionSettings = {
    plateformRestriction: false,
    showEnabled: false,
    showDevices: [""],
    hideEnabled: false,
    hideDevices: [""],
  }

  const updateWidgetPlateformRestrictionSettings = (type, index, value) => {
    setWidgetPlateformRestrictionSettings((prev) => {
      const updated = [...prev[type]];
      updated[index] = value;
      return {
        ...prev,
        [type]: updated,
      };
    });
  };

  const toggleWidgetPlateformRestrictionSettings = (key, checked) => {
    setWidgetPlateformRestrictionSettings((prev) => ({
      ...prev,
      [key]: checked,
    }));
  };

  const initialSchedulerSettings = (days) => {
    let objectData = DAYS.reduce((acc, day) => {
      acc[day] = {
        enabled: !days.includes(day),
        periods: [{ from: "09:00", to: "17:00" }],
      };
      return acc;
    }, {});
    return { ...objectData, ...{ operationTimezone: "" } }
  }

  function getCurrentPreset() {
    if (!widgetSchedulerSettings) return "custom";
    const disabledDays = [];
    const enabledDays = [];
    let timingMismatch = false;
    DAYS.forEach(day => {
      const d = widgetSchedulerSettings[day];
      if (!d) return;
      if (!d.enabled) {
        disabledDays.push(day);
      } else {
        enabledDays.push(day);
        if (
          d.periods?.length !== 1 ||
          d.periods[0].from !== "09:00" ||
          d.periods[0].to !== "17:00"
        ) {
          timingMismatch = true;
        }
      }
    });
    const sort = arr => [...arr].sort().join(",");
    if (timingMismatch) return "custom";
    if (sort(disabledDays) === sort(DAYS)) return "disabled";
    if (sort(disabledDays) === "") return "mon-sun";
    if (sort(disabledDays) === sort(["Sunday"])) return "mon-sat";
    if (sort(disabledDays) === sort(["Sunday", "Saturday"])) return "mon-fri";
    if (
      sort(disabledDays) ===
      sort(["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"])
    ) return "sat-sun";
    return "custom";
  }


  const updateWidgetColorSettings = (key, value) => {
    setWidgetColorSettings((prev) => ({ ...prev, [key]: value }));
  }

  function hasDifferentValue() {
    const keys = new Set([...Object.keys(initialColorSettings), ...Object.keys(widgetColorSettings)]);
    return [...keys].some(key => initialColorSettings?.[key] !== widgetColorSettings?.[key]);
  }

  function isScheduleDifferent() {
    return JSON.stringify(initialSchedulerSettings(["Sunday"])) !== JSON.stringify(widgetSchedulerSettings);
  }

  const generateWidgetCode = ({
    widgetId,
    widgetSrc,
    apiBase,
    chatHttpBase,
    chatWsBase
  }) => {
    return `<script>
(function() {
  if (window.SitePilotChatWidget) return;

  var s = document.createElement("script");
  s.src = "${widgetSrc}";
  s.async = true;

  s.setAttribute("data-widget-id", "${widgetId}");
  s.setAttribute("data-api-base", "${apiBase}");
  s.setAttribute("data-chat-http-base", "${chatHttpBase}");
  s.setAttribute("data-chat-ws-base", "${chatWsBase}");

  document.head.appendChild(s);
})();
</script>`;
  };

  const widgetCode = generateWidgetCode({
    widgetId: widgetId,
    widgetSrc: `${config.baseURL}/widget.js`,
    apiBase: config.API_URL_USER_ONBOARDING,
    chatHttpBase: config.BACKEND_URL,
    chatWsBase: config.CHAT_WS_BASE
  });

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(widgetCode);
      setCopied(true);

      setTimeout(() => {
        setCopied(false);
      }, 2000);
    } catch (err) {
      console.error("Copy failed", err);
    }
  };
  const getWidgetList = async () => {
    let data = await widgetServices.getWidgetList();
    setWidgetList(data?.data || []);
    if ((data?.data || [])?.length > 0) {
      setWidgetId((data?.data || [])?.[0]?.widgetId);
    }
  };

  const getWidgetDetails = async () => {
    setLoader(true);
    let data = await widgetServices.getWidgetDetails(widgetId);
    let result = data?.data || "";
    setWidgetCategory(result?.category || "");

    setVisitorInfoForm(
      result?.widgetSettings?.widgetChatSettings?.visitorInfoForm || false,
    );
    setVisitorInfo(
      result?.widgetSettings?.widgetChatSettings?.visitorInfo || [
        { label: "Name", required: "yes", value: "" },
        { label: "Email", required: "yes", value: "" },
        { label: "Phone", required: "no", value: "" },
        { label: "Company Name", required: "no", value: "" },
      ],
    );

    setWidgetName(
      result?.widgetSettings?.widgetName || result?.widgetName || "",
    );
    setWidgetIdentifier(result?.widgetSettings?.widgetIdentifier || "");
    setWidgetStatus(result?.widgetSettings?.widgetStatus || false);

    setDisableAgentTypingNotification(
      result?.widgetSettings?.notificationSettings
        ?.disableAgentTypingNotification || false,
    );
    setDisableSoundNotification(
      result?.widgetSettings?.notificationSettings?.disableSoundNotification ||
      false,
    );
    setDisableVisitorTypingNotification(
      result?.widgetSettings?.notificationSettings
        ?.disableVisitorTypingNotification || false,
    );
    setDisableMessagePreviewOnDesktop(
      result?.widgetSettings?.notificationSettings
        ?.disableMessagePreviewOnDesktop || false,
    );
    setDisableBrowserTabNotification(
      result?.widgetSettings?.notificationSettings
        ?.disableBrowserTabNotification || false,
    );
    setDisableMessagePreviewOnMobile(
      result?.widgetSettings?.notificationSettings
        ?.disableMessagePreviewOnMobile || false,
    );
    setWidgetVoiceAndVideoCall(
      result?.widgetSettings?.widgetVoiceAndVideoCall || false,
    );
    setWidgetChatLanguage(
      result?.widgetSettings?.widgetChatLanguage || "english",
    );

    setWidgetColorSettings(
      result?.widgetSettings?.widgetColorSettings || initialColorSettings,
    );

    setWidgetSchedulerSettings(
      result?.widgetSettings?.widgetSchedulerSettings || initialSchedulerSettings(["Sunday"]),
    );

    setWidgetConsentSettings(
      result?.widgetSettings?.widgetConsentSettings || initialConsentSettings,
    );

    setWidgetDomainRestrictionSettings(
      result?.widgetSettings?.widgetDomainRestrictionSettings || initialDomainRestrictionSettings,
    );

    setWidgetCountryRestrictionSettings(
      result?.widgetSettings?.widgetCountryRestrictionSettings || initialCountryRestrictionSettings,
    );

    setWidgetPlateformRestrictionSettings(
      result?.widgetSettings?.widgetPlateformRestrictionSettings || initialPlateformRestrictionSettings,
    );

    setHideWhenOffline(
      result?.widgetSettings?.visibilitySettings?.hideWhenOffline || false,
    );
    setHideOnDesktop(
      result?.widgetSettings?.visibilitySettings?.hideOnDesktop || false,
    );
    setHideOnMobile(
      result?.widgetSettings?.visibilitySettings?.hideOnMobile || false,
    );
    setWidgetOfflineWhenAllAgentOffline(
      result?.widgetSettings?.visibilitySettings
        ?.widgetOfflineWhenAllAgentOffline || false,
    );

    setDisableEmojiReaction(
      result?.widgetSettings?.featureSettings?.disableEmojiReaction || false,
    );
    setDisableFileUpload(
      result?.widgetSettings?.featureSettings?.disableFileUpload || false,
    );
    setDisableChatRating(
      result?.widgetSettings?.featureSettings?.disableChatRating || false,
    );
    setDisableChatTranscript(
      result?.widgetSettings?.featureSettings?.disableChatTranscript || false,
    );
    setLoader(false);
  };

  const addUpdateWidget = async () => {
    setSaveLoader(true);
    let widgetSettings = {
      widgetName,
      widgetIdentifier,
      widgetStatus,
      widgetChatLanguage,
      widgetVoiceAndVideoCall,
      widgetColorSettings,
      widgetSchedulerSettings,
      widgetConsentSettings,
      widgetDomainRestrictionSettings,
      widgetCountryRestrictionSettings,
      widgetPlateformRestrictionSettings
    };
    widgetSettings.widgetChatSettings = {
      visitorInfoForm,
      visitorInfo,
    };
    widgetSettings.notificationSettings = {
      disableAgentTypingNotification,
      disableSoundNotification,
      disableVisitorTypingNotification,
      disableMessagePreviewOnDesktop,
      disableBrowserTabNotification,
      disableMessagePreviewOnMobile,
    };
    widgetSettings.visibilitySettings = {
      hideWhenOffline,
      hideOnDesktop,
      hideOnMobile,
      widgetOfflineWhenAllAgentOffline,
    };
    widgetSettings.featureSettings = {
      disableEmojiReaction,
      disableFileUpload,
      disableChatRating,
      disableChatTranscript,
    };
    let data = await widgetServices.addUpdateWidget({
      widgetId,
      widgetSettings,
    });
    if (data?.statusCode === 200) {
      getWidgetList();
    }
    setSaveLoader(false);
  };

  const deleteWidget = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this Widget?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.widgetId = widgetId;
        let data = await widgetServices.deleteWidget(userData);
        if (data?.statusCode === 200) {
          getWidgetList();
        }
      }
    });
  };

  const addVisitorInfoRow = () => {
    setVisitorInfo([...visitorInfo, { label: "", required: "no", value: "" }]);
  };

  const removeVisitorInfoRow = (index) => {
    const updated = [...visitorInfo];
    updated.splice(index, 1);
    setVisitorInfo(updated);
  };

  const handleVisitorInfoChange = (index, field, value) => {
    const updated = [...visitorInfo];
    updated[index][field] = value;
    setVisitorInfo(updated);
  };

  useEffect(() => {
    getWidgetList();
  }, []);

  useEffect(() => {
    if (widgetId) {
      getWidgetDetails();
    }
  }, [widgetId]);
  return (
    <>
      <div className="h-100 d-flex flex-column">
        <div className="bg-white border-bottom px-4 py-3">
          <div className="hstack justify-content-between">
            <h6 className="fw-semibold m-0 d-block">Chat Widget</h6>
            <div className="hstack gap-2">
              <Button
                variant="outline-primary"
                size="sm"
                onClick={toggles?.setToggle}
              >
                Add Widget
              </Button>
              <Button
                onClick={addUpdateWidget}
                disabled={saveLoader}
                variant="primary"
                size="sm"
              >
                Save Widget
              </Button>
            </div>
          </div>
        </div>

        {widgetList?.length > 1 && (
          <div className="bg-white border-bottom px-4 py-3">
            <div className="hstack flex-wrap gap-2">
              {widgetList?.map((item, index) => (
                <InputGroup className="w-auto">
                  <Button
                    key={index}
                    variant={
                      widgetId === item?.widgetId
                        ? "primary"
                        : "outline-primary"
                    }
                    size="sm"
                    onClick={() => setWidgetId(item?.widgetId)}
                  >
                    {item?.widgetName}
                  </Button>
                  {widgetId === item?.widgetId &&
                    item?.category === "secondary" && (
                      <InputGroup.Text
                        title="Delete Widget"
                        onClick={deleteWidget}
                        className="CP"
                      >
                        <GoTrash className="text-danger" />
                      </InputGroup.Text>
                    )}
                </InputGroup>
              ))}
            </div>
          </div>
        )}

        <div className="flex-grow-1 overflow-auto p-4">
          <Row className="g-4">
            <Col xl={6}>
              <Card className="border-0 shadow-sm mb-4">
                <Card.Body>
                  <h6 className="fw-semibold">Widget Name</h6>
                  <Form.Control
                    disabled={widgetCategory === "primary"}
                    onChange={(e) => setWidgetName(e.target.value)}
                    value={widgetName}
                    placeholder="Enter Widget Name"
                  />
                </Card.Body>
              </Card>

              <Card className="border-0 shadow-sm mb-4">
                <Card.Body>
                  <h6 className="fw-semibold">Widget ID</h6>
                  <Form.Group className="mb-2">
                    <Form.Label>
                      Chat URL (
                      <Form.Text
                        className="text-muted"
                        style={{ fontSize: 10 }}
                      >
                        This is the unique Live Chat URL
                      </Form.Text>
                      )
                    </Form.Label>
                    <InputGroup>
                      <InputGroup.Text style={{ fontSize: 12 }}>
                        {config.baseURL}/widget/
                      </InputGroup.Text>
                      <Form.Control
                        onChange={(e) => setWidgetIdentifier(e.target.value)}
                        value={widgetIdentifier}
                        placeholder="Enter Widget identifier"
                      />
                      <InputGroup.Text className="CP" title="Copy URL">
                        <FiCopy />
                      </InputGroup.Text>
                      <InputGroup.Text className="CP" title="View Chat">
                        <FiEye />
                      </InputGroup.Text>
                    </InputGroup>
                  </Form.Group>
                </Card.Body>
              </Card>
              <Card className="border-0 shadow-sm mb-4">
                <Card.Body>
                  <div className="hstack justify-content-between mb-2">
                    <h6 className="fw-semibold m-0">Widget Color</h6>
                    <div className="hstack gap-2">
                      {hasDifferentValue() &&
                        <Button
                          style={{ fontSize: 11 }}
                          size="sm"
                          variant="outline-danger"
                          onClick={() => setWidgetColorSettings(initialColorSettings)}
                        >
                          Reset
                        </Button>
                      }
                      <Button
                        style={{ fontSize: 11 }}
                        size="sm"
                        variant="outline-primary"
                        onClick={toggles.setToggle3}
                      >
                        Advance
                      </Button>
                    </div>
                  </div>
                  <Form.Group className="hstack flex-wrap gap-1">
                    {colors.map((color, index) => (
                      <div
                        key={index}
                        onClick={() => updateWidgetColorSettings("color", color)}
                        style={{
                          width: 25,
                          height: 25,
                          backgroundColor: color,
                          borderRadius: 4,
                          cursor: "pointer",
                          border:
                            widgetColorSettings?.color === color
                              ? "2px solid #000"
                              : "1px solid #ccc",
                        }}
                        title={color}
                      />
                    ))}
                  </Form.Group>
                </Card.Body>
              </Card>
              <Card className="border-0 shadow-sm mb-4">
                <Card.Body>
                  <div className="hstack justify-content-between mb-2">
                    <h6 className="fw-semibold m-0">Scheduler</h6>
                    <div className="hstack gap-2">
                      {isScheduleDifferent() &&
                        <Button
                          style={{ fontSize: 11 }}
                          size="sm"
                          variant="outline-danger"
                          onClick={() => setWidgetSchedulerSettings(initialSchedulerSettings(["Sunday"]))}
                        >
                          Reset
                        </Button>
                      }
                      <Button
                        style={{ fontSize: 11 }}
                        size="sm"
                        variant="outline-primary"
                        onClick={toggles.setToggle2}
                      >
                        Advance
                      </Button>
                    </div>
                  </div>
                  <Form.Select
                    size="sm"
                    value={getCurrentPreset()}
                    onChange={(e) => {
                      const val = e.target.value;
                      const map = {
                        disabled: DAYS,
                        "mon-sun": [],
                        "mon-sat": ["Sunday"],
                        "mon-fri": ["Sunday", "Saturday"],
                        "sat-sun": [
                          "Monday",
                          "Tuesday",
                          "Wednesday",
                          "Thursday",
                          "Friday",
                        ],
                      };
                      if (map[val]) {
                        setWidgetSchedulerSettings(
                          initialSchedulerSettings(map[val])
                        );
                      }
                    }}
                  >
                    <option value="custom">Custom</option>
                    <option value="disabled">Disabled</option>
                    <option value="mon-sun">Mon - Sun (9am - 5pm)</option>
                    <option value="mon-sat">Mon - Sat (9am - 5pm)</option>
                    <option value="mon-fri">Mon - Fri (9am - 5pm)</option>
                    <option value="sat-sun">Sat - Sun (9am - 5pm)</option>
                  </Form.Select>

                </Card.Body>
              </Card>
              <Card className="border-0 shadow-sm mb-4">
                <Card.Body>
                  <div className="hstack justify-content-between mb-2">
                    <h6 className="fw-semibold m-0">Consent Form</h6>
                    <div className="hstack gap-2">
                      {(widgetConsentSettings?.requireConsent === "everyone") &&
                        <Button
                          style={{ fontSize: 11 }}
                          size="sm"
                          variant="outline-danger"
                          onClick={() => setWidgetConsentSettings(initialConsentSettings)}
                        >
                          Reset
                        </Button>
                      }
                      <Button
                        style={{ fontSize: 11 }}
                        size="sm"
                        variant="outline-primary"
                        onClick={toggles.setToggle1}
                      >
                        Advance
                      </Button>
                    </div>
                  </div>
                  <Form.Select
                    size="sm"
                    name="requireConsent"
                    value={widgetConsentSettings?.requireConsent}
                    onChange={widgetConsentChangeSettings}
                  >
                    <option value="disabled">Disabled</option>
                    <option value="everyone">Everyone</option>
                  </Form.Select>
                </Card.Body>
              </Card>
              <Card className="border-0 shadow-sm mb-4">
                <Card.Body>
                  <h6 className="fw-semibold">Widget Content</h6>
                  <Form.Group className="mb-2">
                    <Form.Label>Languages</Form.Label>
                    <Form.Select
                      onChange={(e) => setWidgetChatLanguage(e.target.value)}
                      value={widgetChatLanguage}
                      size="sm">
                      <option value="hindi">Hindi</option>
                      <option value="english">English</option>
                    </Form.Select>
                  </Form.Group>
                  <Form.Check
                    style={{ fontSize: 13 }}
                    type="switch"
                    onChange={(e) => setWidgetVoiceAndVideoCall(e.target.checked)}
                    checked={widgetVoiceAndVideoCall}
                    label="Video + Voice + Screensharing (Add-on Inactive)"
                  />
                </Card.Body>
              </Card>
              <Card className="border-0 shadow-sm mb-4">
                <Card.Body>
                  <h6 className="fw-semibold">Availability Restriction</h6>
                  <Form.Group>
                    <div className="hstack justify-content-between mb-2">
                      <Form.Label>Domain Restriction</Form.Label>
                      <div className="hstack gap-2">
                        {widgetDomainRestrictionSettings?.domainRestriction &&
                          <Button
                            style={{ fontSize: 11 }}
                            size="sm"
                            onClick={() => setWidgetDomainRestrictionSettings(initialDomainRestrictionSettings)}
                            variant="outline-danger"
                          >
                            Reset
                          </Button>
                        }
                        <Button
                          style={{ fontSize: 11 }}
                          size="sm"
                          variant="outline-primary"
                          onClick={toggles.setToggle4}
                        >
                          Configure
                        </Button>
                      </div>
                    </div>
                    <Form.Check
                      type="switch"
                      style={{ fontSize: 13 }}
                      onChange={(e) => updateWidgetDomainRestrictionSettings("domainRestriction", e.target.checked)}
                      checked={widgetDomainRestrictionSettings?.domainRestriction}
                      label="Disabled - configure to enable"
                    />
                    <div className="lh-1">
                      <Form.Text style={{ fontSize: 11 }}>
                        By default, the code will work on all the domains and
                        URLs where it has been inserted. To show or hide the
                        widget on one or more specific domain or URLs, enable
                        this functionality and specify the rule.
                      </Form.Text>
                    </div>
                  </Form.Group>
                  <Form.Group className="mt-4">
                    <div className="hstack justify-content-between mb-2">
                      <Form.Label>Country Restriction</Form.Label>
                      <div className="hstack gap-2">
                        {widgetCountryRestrictionSettings?.countryRestriction &&
                          <Button
                            style={{ fontSize: 11 }}
                            size="sm"
                            onClick={() => setWidgetCountryRestrictionSettings(initialCountryRestrictionSettings)}
                            variant="outline-danger"
                          >
                            Reset
                          </Button>
                        }
                        <Button
                          style={{ fontSize: 11 }}
                          size="sm"
                          variant="outline-primary"
                          onClick={toggles.setToggle5}
                        >
                          Configure
                        </Button>
                      </div>
                    </div>
                    <Form.Check
                      type="switch"
                      style={{ fontSize: 13 }}
                      onChange={(e) => updateWidgetCountryRestrictionSettings("countryRestriction", e.target.checked)}
                      checked={widgetCountryRestrictionSettings?.countryRestriction}
                      label="Disabled - configure to enable"
                    />
                    <div className="lh-1">
                      <Form.Text style={{ fontSize: 11 }}>
                        By default, the widget will be shown to all visitors. To
                        show or hide the widget for visitors from specific
                        countries, enable this functionality and specify the
                        countries.
                      </Form.Text>
                    </div>
                  </Form.Group>
                  <Form.Group className="mt-4">
                    <div className="hstack justify-content-between mb-2">
                      <Form.Label>Plateform Restriction</Form.Label>
                      <div className="hstack gap-2">
                        {widgetPlateformRestrictionSettings?.plateformRestriction &&
                          <Button
                            style={{ fontSize: 11 }}
                            size="sm"
                            onClick={() => setWidgetPlateformRestrictionSettings(initialPlateformRestrictionSettings)}
                            variant="outline-danger"
                          >
                            Reset
                          </Button>
                        }
                        <Button
                          style={{ fontSize: 11 }}
                          size="sm"
                          variant="outline-primary"
                          onClick={toggles.setToggle6}
                        >
                          Configure
                        </Button>
                      </div>
                    </div>
                    <Form.Check
                      type="switch"
                      style={{ fontSize: 13 }}
                      onChange={(e) => updateWidgetPlateformRestrictionSettings("plateformRestriction", e.target.checked)}
                      checked={widgetPlateformRestrictionSettings?.plateformRestriction}
                      label="Disabled - configure to enable"
                    />
                    <div className="lh-1">
                      <Form.Text style={{ fontSize: 11 }}>
                        By default, the widget will be shown to all visitors. To
                        show or hide the widget for visitors from specific
                        platforms, enable this functionality and specify the
                        platforms.
                      </Form.Text>
                    </div>
                  </Form.Group>
                </Card.Body>
              </Card>
            </Col>
            {/* RIGHT COLUMN */}
            <Col xl={6}>
              <Card className="border-0 shadow-sm mb-4">
                <Card.Body>
                  <div className="hstack justify-content-between mb-2">
                    <h6 className="fw-semibold m-0">Widget Code</h6>
                    <Form.Check
                      type="switch"
                      style={{ fontSize: 13 }}
                      onChange={(e) => setWidgetStatus(e.target.checked)}
                      checked={widgetStatus}
                    />
                  </div>
                  <Form.Control
                    as="textarea"
                    rows={7}
                    readOnly
                    className="CP px-1 py-2"
                    value={widgetCode}
                    style={{
                      fontFamily: "monospace",
                      borderRadius: "6px",
                      fontSize: "13px",
                      lineHeight: "1.5",
                      whiteSpace: "pre",
                    }}
                  />

                  <div className="hstack justify-content-end mt-2">
                    <Button
                      size="sm"
                      style={{ fontSize: 11 }}
                      variant={copied ? "success" : "outline-primary"}
                      onClick={handleCopy}
                      className="hstack gap-1 justify-content-center"
                    >
                      {copied ? (
                        <>
                          <FiCheck size={12} /> Copied
                        </>
                      ) : (
                        <>
                          <FiCopy size={12} /> Copy
                        </>
                      )}
                    </Button>
                  </div>
                </Card.Body>
              </Card>
              <Card className="border-0 shadow-sm mb-4">
                <Card.Body>
                  <div className="hstack justify-content-between mb-2">
                    <h6 className="fw-semibold m-0">
                      Visitor Information Form
                    </h6>
                    <Form.Check
                      type="switch"
                      style={{ fontSize: 13 }}
                      onChange={(e) => setVisitorInfoForm(e.target.checked)}
                      checked={visitorInfoForm}
                    />
                  </div>
                  {visitorInfoForm && (
                    <Form.Group className="mb-2">
                      <div className="hstack gap-2">
                        <Form.Label>Visitor Information</Form.Label>
                        <CiSquarePlus
                          title="Add More"
                          className="mb-1 text-success CP"
                          onClick={addVisitorInfoRow}
                        />
                      </div>
                      {visitorInfo.map((item, index) => (
                        <Row key={index} className="g-2 mb-2 align-items-center">
                          <Col md={4}>
                            <Form.Control
                              placeholder="Enter Label"
                              value={item.label}
                              disabled={
                                item?.label === "Name" ||
                                item?.label === "Email" ||
                                item?.label === "Phone" ||
                                item?.label === "Company Name"
                              }
                              onChange={(e) =>
                                handleVisitorInfoChange(
                                  index,
                                  "label",
                                  e.target.value,
                                )
                              }
                            />
                          </Col>
                          <Col md={4}>
                            <Form.Select
                              onChange={(e) =>
                                handleVisitorInfoChange(
                                  index,
                                  "required",
                                  e.target.value,
                                )
                              }
                              disabled={
                                item?.label === "Name" ||
                                item?.label === "Email"
                              }
                              value={item.required}
                            >
                              <option value={"no"}>Non-Mandatory</option>
                              <option value={"yes"}>Mandatory</option>
                            </Form.Select>
                          </Col>
                          <Col md={3}>
                            <Form.Control placeholder="Enter Value" disabled />
                          </Col>
                          <Col md={1}>
                            <GoTrash
                              style={{ fontSize: 15 }}
                              className={`${item?.label === "Name" || item?.label === "Email" ? "text-muted" : "text-danger CP"}`}
                              title={
                                !(
                                  item?.label === "Name" ||
                                  item?.label === "Email"
                                )
                                  ? "Delete"
                                  : "Not Deleted (Because This field required for Indentify)"
                              }
                              onClick={() => {
                                if (
                                  !(
                                    item?.label === "Name" ||
                                    item?.label === "Email"
                                  )
                                )
                                  removeVisitorInfoRow(index);
                              }}
                            />
                          </Col>
                        </Row>
                      ))}
                    </Form.Group>
                  )}
                </Card.Body>
              </Card>
              <Card className="border-0 shadow-sm mb-4">
                <Card.Body>
                  <h6 className="fw-semibold">Widget Behavior</h6>
                  <Form.Group className="mb-4">
                    <Form.Label>Notification Settings</Form.Label>
                    <Form.Check
                      style={{ fontSize: 13 }}
                      onChange={(e) =>
                        setHideEstimatedWaitTime(e.target.checked)
                      }
                      checked={hideEstimatedWaitTime}
                      type="switch"
                      label="Hide estimated wait time"
                    />
                    <Form.Check
                      style={{ fontSize: 13 }}
                      onChange={(e) =>
                        setDisableAgentTypingNotification(e.target.checked)
                      }
                      checked={disableAgentTypingNotification}
                      type="switch"
                      label="Disable agent typing notification"
                    />
                    <Form.Check
                      style={{ fontSize: 13 }}
                      onChange={(e) =>
                        setDisableSoundNotification(e.target.checked)
                      }
                      checked={disableSoundNotification}
                      type="switch"
                      label="Disable sound notification"
                    />
                    <Form.Check
                      style={{ fontSize: 13 }}
                      onChange={(e) =>
                        setDisableVisitorTypingNotification(e.target.checked)
                      }
                      checked={disableVisitorTypingNotification}
                      type="switch"
                      label="Disable visitor typing function"
                    />
                    <Form.Check
                      style={{ fontSize: 13 }}
                      onChange={(e) =>
                        setDisableMessagePreviewOnDesktop(e.target.checked)
                      }
                      checked={disableMessagePreviewOnDesktop}
                      type="switch"
                      label="Disable message preview on desktop"
                    />
                    <Form.Check
                      style={{ fontSize: 13 }}
                      onChange={(e) =>
                        setDisableBrowserTabNotification(e.target.checked)
                      }
                      checked={disableBrowserTabNotification}
                      type="switch"
                      label="Disable browser tab notification"
                    />
                    <Form.Check
                      style={{ fontSize: 13 }}
                      onChange={(e) =>
                        setDisableMessagePreviewOnMobile(e.target.checked)
                      }
                      checked={disableMessagePreviewOnMobile}
                      type="switch"
                      label="Disable message preview on mobile"
                    />
                  </Form.Group>
                  <Form.Group className="mb-4">
                    <Form.Label>Visibility Settings</Form.Label>
                    <Form.Check
                      style={{ fontSize: 13 }}
                      onChange={(e) => setHideWhenOffline(e.target.checked)}
                      checked={hideWhenOffline}
                      type="switch"
                      label="Hide when offline"
                    />
                    <Form.Check
                      style={{ fontSize: 13 }}
                      onChange={(e) => setHideOnDesktop(e.target.checked)}
                      checked={hideOnDesktop}
                      type="switch"
                      label="Hide on desktop"
                    />
                    <Form.Check
                      style={{ fontSize: 13 }}
                      onChange={(e) => setHideOnMobile(e.target.checked)}
                      checked={hideOnMobile}
                      type="switch"
                      label="Hide on mobile"
                    />
                    <Form.Check
                      style={{ fontSize: 13 }}
                      onChange={(e) =>
                        setWidgetOfflineWhenAllAgentOffline(e.target.checked)
                      }
                      checked={widgetOfflineWhenAllAgentOffline}
                      type="switch"
                      label="Widget offline when all Agent(s) offline"
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>Feature Settings</Form.Label>
                    <Form.Check
                      style={{ fontSize: 13 }}
                      onChange={(e) =>
                        setDisableEmojiReaction(e.target.checked)
                      }
                      checked={disableEmojiReaction}
                      type="switch"
                      label="Disable emoji reaction"
                    />
                    <Form.Check
                      style={{ fontSize: 13 }}
                      onChange={(e) => setDisableFileUpload(e.target.checked)}
                      checked={disableFileUpload}
                      type="switch"
                      label="Disable file upload"
                    />
                    <Form.Check
                      style={{ fontSize: 13 }}
                      onChange={(e) => setDisableChatRating(e.target.checked)}
                      checked={disableChatRating}
                      type="switch"
                      label="Disable chat rating"
                    />
                    <Form.Check
                      style={{ fontSize: 13 }}
                      onChange={(e) =>
                        setDisableChatTranscript(e.target.checked)
                      }
                      checked={disableChatTranscript}
                      type="switch"
                      label="Disable chat transcript"
                    />
                  </Form.Group>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
      <AddWidget
        show={!toggles.toggle}
        hide={() => toggles.setToggle()}
        title={`Add Widget`}
        getWidgetList={getWidgetList}
      />
      <AdvanceConsentForm
        show={!toggles.toggle1}
        hide={() => toggles.setToggle1()}
        title={`Consent Form`}
        initialConsentSettings={initialConsentSettings}
        widgetConsentSettings={widgetConsentSettings}
        widgetConsentChangeSettings={widgetConsentChangeSettings}
        setWidgetConsentSettings={setWidgetConsentSettings}
      />
      <AdvanceScheduler
        show={!toggles.toggle2}
        hide={() => toggles.setToggle2()}
        title={`Scheduler`}
        DAYS={DAYS}
        initialSchedulerSettings={initialSchedulerSettings}
        setWidgetSchedulerSettings={setWidgetSchedulerSettings}
        widgetSchedulerSettings={widgetSchedulerSettings}
        isScheduleDifferent={isScheduleDifferent}
      />
      <AdvanceWidgetAppearance
        show={!toggles.toggle3}
        hide={() => toggles.setToggle3()}
        title={`Widget Appearance`}
        colors={colors}
        initialColorSettings={initialColorSettings}
        setWidgetColorSettings={setWidgetColorSettings}
        widgetColorSettings={widgetColorSettings}
        updateWidgetColorSettings={updateWidgetColorSettings}
        hasDifferentValue={hasDifferentValue}
      />
      <ConfigureDomainRestriction
        show={!toggles.toggle4}
        hide={() => toggles.setToggle4()}
        title={`Domain Restriction`}
        widgetDomainRestrictionSettings={widgetDomainRestrictionSettings}
        setWidgetDomainRestrictionSettings={setWidgetDomainRestrictionSettings}
        initialDomainRestrictionSettings={initialDomainRestrictionSettings}
        updateWidgetDomainRestrictionSettings={updateWidgetDomainRestrictionSettings}
        toggleWidgetDomainRestrictionSettings={toggleWidgetDomainRestrictionSettings}
      />
      <ConfigureCountryRestriction
        show={!toggles.toggle5}
        hide={() => toggles.setToggle5()}
        title={`Country Restriction`}
        widgetCountryRestrictionSettings={widgetCountryRestrictionSettings}
        setWidgetCountryRestrictionSettings={setWidgetCountryRestrictionSettings}
        initialCountryRestrictionSettings={initialCountryRestrictionSettings}
        updateWidgetCountryRestrictionSettings={updateWidgetCountryRestrictionSettings}
        toggleWidgetCountryRestrictionSettings={toggleWidgetCountryRestrictionSettings}
      />
      <ConfigurePlateformRestriction
        show={!toggles.toggle6}
        hide={() => toggles.setToggle6()}
        title={`Plateform Restriction`}
        widgetPlateformRestrictionSettings={widgetPlateformRestrictionSettings}
        setWidgetPlateformRestrictionSettings={setWidgetPlateformRestrictionSettings}
        initialPlateformRestrictionSettings={initialPlateformRestrictionSettings}
        updateWidgetPlateformRestrictionSettings={updateWidgetPlateformRestrictionSettings}
        toggleWidgetPlateformRestrictionSettings={toggleWidgetPlateformRestrictionSettings}
      />
    </>
  );
};

export default ChatWidgetData;
